/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { HlpDetailsDto, HlpListItemDto, HlpStatus } from './hlp.dto';
import {
  arrayOf,
  createEnum,
  date,
  DateFormat,
  entity,
  enumeration,
  EnumSet,
  subentity,
} from '@gh/core-data';
import { QuotationBase, QuotationStructureSaveRequestDto } from './quotation.dto';
import { DirtyType } from '@gh/common-shared-data';

export const ListingStatus = createEnum('LISTING_STATUS', {
  new: 1,
  forSale: 2,
  sold: 3,
  underContract: 4,
  underConstruction: 5,
});

export type ListingStatus = EnumSet<typeof ListingStatus>;

export const Storeys = createEnum('STOREYS', {
  Single: 1,
  Double: 2,
  Triple: 3,
});

export type Storeys = EnumSet<typeof Storeys>;

export const LandAreaUom = {
  sqm: 'sqm',
  sqft: 'sqft',
};

export const AutoSaveMin = createEnum('AUTO_SAVE_MIN', {
  '5': 5,
  '10': 10,
  '15': 15,
  '30': 30,
  '40': 40,
  '60': 60,
});

export type AutoSaveMin = EnumSet<typeof AutoSaveMin>;

export const HlpListItemMapper = entity<HlpListItemDto>({
  updatedDate: date(DateFormat.DateTime),
  addedDate: date(DateFormat.DateTime),
  statusValue: enumeration(HlpStatus),
});

export const HlpDetailsMapper = entity<HlpDetailsDto>({
  listingStatus: enumeration(ListingStatus),
  status: enumeration(HlpStatus),
  storeys: enumeration(Storeys),
  base: enumeration(QuotationBase),
  variations: arrayOf(subentity<QuotationStructureSaveRequestDto>({
    dirtyType: enumeration(DirtyType),
  })),
});
export const HlpDeleteMapper = entity<HlpDetailsDto>({
  listingStatus: enumeration(ListingStatus),
});

export const buildHlpBrochureLink = (websiteLink: string): string => {
  try {
    const url = new URL(websiteLink);
    url.searchParams.set('pdf', '1');
    return url.toString();
  } catch {
    const separator = websiteLink.includes('?') ? '&' : '?';
    return `${websiteLink}${separator}pdf=1`;
  }
};
